import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@vds/modals';
import { v4 as uuidv4 } from 'uuid';
import { isMoversPhase3 } from '../../Movers/common/utils';

export class VDSModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.id = props.id ? props.id : uuidv4();
  }

  modalOpenedChange = (value) => {
    // const { onOpenedChange, id, event, data, ariaLabel } = this.props;
    const { onOpenedChange, id, openViewData } = this.props;

    // const defaultPayload = {
    //   name: id || ariaLabel || `${window?.vzdl?.page?.name || window?.location?.pathname?.split('/')?.pop()?.split('.')?.[0] || 'pagename'}-modal`,
    //   selector: `#${id || `id-${this.id}`}`,
    // };

    // if (this.props?.event) {
    //   defaultPayload.event = event;
    // }
    // if (this.props?.data) {
    //   defaultPayload.data = data;
    // }
    let closeDefaultPayload = {
      name: id,
      selector: `#${id}`,
    }
    if(isMoversPhase3()){
      closeDefaultPayload = {type:"",name:"choose a store for pickup modal"};
    }
    if (onOpenedChange && typeof onOpenedChange === 'function') {
      onOpenedChange(value);
    }
    if (value && window?.vztag?.api?.dispatch && openViewData) {
      window.vztag.api.dispatch('openView', openViewData);
      // window.vztag.api.dispatch('openView', defaultPayload);
    } else if (!value && window?.vztag?.api?.dispatch) {
      window.vztag.api.dispatch('closeView', closeDefaultPayload);
    }
  };

  render() {
    const { children, id } = this.props;
    return (
      <Modal id={id || `id-${this.id}`} {...this.props} onOpenedChange={this.modalOpenedChange} disableOutsideClick>
        {children}
      </Modal>
    );
  }
}

VDSModal.propTypes = {
  onOpenedChange: PropTypes.func,
  id: PropTypes.string,
  children: PropTypes.array,
  // event: PropTypes.string,
  // data: PropTypes.object,
  // ariaLabel: PropTypes.string,
  openViewData: PropTypes.object,
};
